import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { SectionContainer, SectionTitle } from '../../shared/sectionable/styles';
import propTypes from '../common/prop-types';
import Details from './info-components/details';
import { scrollIfHashMatch } from '../../shared/navigation/utils';

const Container = styled(SectionContainer)`
  margin-top: 48px;
  margin-bottom: 120px;

  ${props => (props.theme.isMobile ? `
    margin-bottom: 80px;
  ` : `
    &:not(:first-child) {
      border-top: 1px solid #d7dfe7;
      padding-top: 72px;
    }
  `)};
`;

const sectionName = 'fund-information';

export default function Info({ fund }) {
  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
  }, {});

  return (
    <Container name={sectionName}>
      <SectionTitle>information</SectionTitle>
      <Details fund={fund} />
    </Container>
  );
}

/* eslint-disable-next-line react/require-default-props */
Info.propTypes = { fund: propTypes.fund };
